"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_BANNER = exports.BROADCAST_TOGGLE_BANNER_HIDDEN = exports.BROADCAST_SYNC_BANNERS_STATUS = void 0;
var BROADCAST_TOGGLE_BANNER_HIDDEN = exports.BROADCAST_TOGGLE_BANNER_HIDDEN = 'BROADCAST_TOGGLE_BANNER_HIDDEN';
var BROADCAST_SYNC_BANNERS_STATUS = exports.BROADCAST_SYNC_BANNERS_STATUS = 'BROADCAST_SYNC_BANNERS_STATUS';
var UPDATE_BANNER = exports.UPDATE_BANNER = 'UPDATE_BANNER';